import { Component, ComponentFactoryResolver, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { CONTACT_FORM, MODAL_CLOSE_ACTIONS } from '@shared/constants/common.constants';
import { LocationManagerService } from '@cakeiteasy/web-utils';
import { CieUtilsModalManagerService } from '@cakeiteasy/web-utils';
import { ContactUsModalComponent } from '@modals/contact-us-modal/contact-us-modal.component';
import { HowItWorksModalComponent } from '@modals/how-it-works-modal/how-it-works-modal.component';
import { getTranslatedLinkBlocks } from '@helpers/links-helper';
import { Router } from '@angular/router';
import { APP_ROUTES } from '@entire/route-names';

interface IMarketingUrls {
  facebook: string;
  instagram: string;
}

const MARKETING_URLS: { [key: string]: IMarketingUrls } = {
  no: {
    instagram: 'https://www.instagram.com/cakeiteasy.no/',
    facebook: 'https://www.facebook.com/cakeiteasy.no/'
  },
  se: {
    instagram: 'https://www.instagram.com/cakeiteasy.se/',
    facebook: 'https://www.facebook.com/cakeiteasy.se/'
  }
};

@Component({
  standalone: false,
  selector: 'footer-layout',
  templateUrl: './footer-layout.component.html',
  styleUrls: ['./footer-layout.component.scss'],
})
export class FooterLayoutComponent implements OnInit {
  @Input() giftCardsEnabled: boolean;

  public linksCount = 10;
  public footerLinks = [];
  public urls: IMarketingUrls;

  public footerLinksKeys = ['customerService', 'information', 'inspiration'];

  public isNOLocale: boolean;
  public isSELocale: boolean;

  public currentYear: number;

  constructor(private _translate: TranslateService,
              private _locationManager: LocationManagerService,
              private _modalManager: CieUtilsModalManagerService,
              private _componentResolver: ComponentFactoryResolver,
              private _router: Router) {
  }

  ngOnInit() {
    const domainName = this._locationManager.getDomainName();
    this.urls = MARKETING_URLS[domainName];

    this.footerLinks = getTranslatedLinkBlocks(this.footerLinksKeys, this.linksCount, this._translate);
    this.isNOLocale = domainName === 'no';
    this.isSELocale = domainName === 'se';

    this.currentYear = new Date().getFullYear();
  }

  public showContactUs(showBack = true) {
    this._modalManager
      .show(ContactUsModalComponent, this._componentResolver, {
          showBack,
          showedForm: CONTACT_FORM.CONTACT_US
        },
        { windowClass: 'modal-simple lg' });
  }

  public showHowItWorks() {
    this._modalManager
      .show(HowItWorksModalComponent, this._componentResolver, {}, { windowClass: 'modal-xl-4 how-it-works-modal' })
      .then((result) => {
        if (result === MODAL_CLOSE_ACTIONS.OPEN_CONTACT_US) {
          this.showContactUs(false);
        }
      });
  }

  public showFAQ() {
    this._modalManager
      .show(ContactUsModalComponent, this._componentResolver, {
          showedForm: CONTACT_FORM.FAQ
        },
        { windowClass: 'modal-simple lg' });
  }

  public goToGiftCards() {
    this._router.navigate(['/', APP_ROUTES.GIFT_CARDS]);
  }
}
